// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__24P0f","col":"styles_col__184fU"};